// @flow

import ImageSquareFit, { IMAGE_FIT_TYPES } from './ImageSquareFit'

export { IMAGE_FIT_TYPES }

export default ImageSquareFit
